import {
  MEDIA_ALPHA_CUTOUT,
  MEDIA_ALPHA_OPAQUE,
} from './mediaAlpha'

const OPAQUE_OPACITY = 0.999
const CUTOUT_ALPHA_TEST = 0.5

const normalizeOpacity = (value) => {
  const opacity = Number(value)
  if (!Number.isFinite(opacity)) return 1
  return Math.max(0, Math.min(1, opacity))
}

export function resolveMediaMaterialMode(alphaInfo, opacity = 1) {
  const safeOpacity = normalizeOpacity(opacity)
  const mode = alphaInfo?.mode || null

  if (safeOpacity >= OPAQUE_OPACITY && mode === MEDIA_ALPHA_OPAQUE) {
    return {
      kind: 'opaque',
      opacity: safeOpacity,
      transparent: false,
      alphaTest: 0,
      depthWrite: true,
    }
  }

  if (safeOpacity >= OPAQUE_OPACITY && mode === MEDIA_ALPHA_CUTOUT) {
    return {
      kind: 'cutout',
      opacity: safeOpacity,
      transparent: false,
      alphaTest: CUTOUT_ALPHA_TEST,
      depthWrite: true,
    }
  }

  return {
    kind: 'blended',
    opacity: safeOpacity,
    transparent: true,
    alphaTest: 0,
    depthWrite: false,
  }
}

export function applyMediaMaterialMode(material, alphaInfo, opacity = material?.opacity ?? 1) {
  if (!material) return null

  const next = resolveMediaMaterialMode(alphaInfo, opacity)
  const prev = material.userData?.__vybyMediaMaterialMode || {}
  const changed =
    prev.kind !== next.kind ||
    material.transparent !== next.transparent ||
    material.alphaTest !== next.alphaTest ||
    material.depthWrite !== next.depthWrite

  material.opacity = next.opacity
  material.transparent = next.transparent
  material.alphaTest = next.alphaTest
  material.depthWrite = next.depthWrite
  material.depthTest = true
  material.userData = {
    ...(material.userData || {}),
    __vybyMediaMaterialMode: {
      ...next,
      alphaMode: alphaInfo?.mode || null,
      alphaReason: alphaInfo?.reason || null,
    },
  }

  if (changed) material.needsUpdate = true
  return material.userData.__vybyMediaMaterialMode
}
